import { getApiUrl } from "../config/brands";
import { ADMIN_TOKEN_NSP } from "../constants";

const createAuthProvider = (brand) => {
  const apiUrl = getApiUrl(brand);

  return {
    // authentication
    login: async ({ username: email, password }) => {
      // El login ya se hace desde LoginPage
      // Este método es para mantener compatibilidad con react-admin
      return Promise.resolve();
    },
    checkError: (error) => {
      const status = error.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem(ADMIN_TOKEN_NSP);
        localStorage.removeItem("selectedBrand");
        return Promise.reject();
      }

      return Promise.resolve();
    },
    checkAuth: () =>
      localStorage.getItem(ADMIN_TOKEN_NSP)
        ? Promise.resolve()
        : Promise.reject(),
    logout: () => {
      localStorage.removeItem(ADMIN_TOKEN_NSP);
      localStorage.removeItem("selectedBrand");
      // Redirigir a /login sin el basename del brand
      window.location.href = "/login";
      return Promise.reject();
    },
    getIdentity: () => Promise.resolve({ name: "Admin" }),
    // authorization
    getPermissions: (params) => Promise.resolve(),
  };
};

export default createAuthProvider;
